var _defs, _mask, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQrcodePhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 119,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-1.2%",
    y: "-11.9%",
    width: "102.4%",
    height: "123.8%",
    filterUnits: "objectBoundingBox",
    id: "a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M6.799 0C3.044 0 0 2.796 0 6.245v87.433c0 3.45 3.044 6.245 6.799 6.245h45.325c3.755 0 6.799-2.796 6.799-6.245V6.245c0-3.45-3.044-6.245-6.799-6.245H6.799z",
    id: "b"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)",
    transform: "translate(-15 9)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(24 1)"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b"
  }))), /*#__PURE__*/React.createElement("use", {
    fill: "#EADCC9",
    style: {
      mixBlendMode: "multiply"
    },
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    fill: "#EADCC9",
    style: {
      mixBlendMode: "multiply"
    },
    mask: "url(#c)",
    d: "m-20.566-10.984 43.126-1.263-3.031 97.225-43.126 1.263z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D33F71",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M6 88h47V14H6z",
    transform: "translate(24)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 34v3.11H39.379V47h-3.377v-9.89H36V34h14zM36.5 53.5h3.149l-.001 10.588H49.5v3.41h-9.852v.002h-3.147v-14zM72 34v3.102h-.003V47h-3.41v-9.898H58v-3.101h14zM71.5 67.5h-3.187l.001-.003H58.5v-3.426l9.814-.001-.001-10.57h3.186v14z",
    fill: "#FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43 49.444h2.333v2.112H43v-2.112zm9.333-6.333h2.334v4.222h-2.334v-4.222zM50 49.444h4.667v4.223H52.36V51.53H50v-2.087zm6.989 0h2.355v2.082h2.3v-2.082H64v2.082h-2.355v2.13H64v4.213h-2.355V60h-2.3v-2.13h-4.711V60h-2.3v-4.212h4.655v-2.131h2.355v-2.131H56.99v-2.082zm2.344 8.445h2.334v-4.222h-2.334v4.222zM57 41h7v6.333h-7V41zm2.333 2.111v2.111h2.334v-2.11h-2.334zM43 41h7v6.333h-7V41zm2.333 2.111v2.111h2.334v-2.11h-2.334zM43 53.667h7V60h-7v-6.333zm2.333 2.11v2.112h2.334v-2.111h-2.334z",
    fill: "#FFF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrcodePhone);
export default __webpack_public_path__ + "static/media/qrcodePhone.16d9d89fbf8901c3674a93b09204491e.svg";
export { ForwardRef as ReactComponent };